import Http from '../../../../http';

import {
  FETCH_PO_LOCATIONS,
  FETCH_PO_LOCATIONS_ERROR,
  FETCH_PO_LOCATIONS_SUCCESS,
  PO_LOCATION_UPDATED,
} from './constants';

export const fetchLocationsStart = () => ({
  type: FETCH_PO_LOCATIONS,
});

export const fetchLocationsSuccess = data => ({
  type: FETCH_PO_LOCATIONS_SUCCESS,
  payload: data,
});

export const fetchLocationsError = error => ({
  type: FETCH_PO_LOCATIONS_ERROR,
  payload: error,
});

export const fetchLocations = brandId => (dispatch) => {
  dispatch(fetchLocationsStart());
  return Http.get(`/brand/${brandId}/purchase-order/location-setting`)
    .then((data) => {
      dispatch(fetchLocationsSuccess(data));
      return data;
    })
    .catch((error) => {
      dispatch(fetchLocationsError(error));
      throw error;
    });
};

export const poLocationUpdated = location => ({
  type: PO_LOCATION_UPDATED,
  payload: location,
});

export const updatePoLocation = (shopId, update) => dispatch => (
 Http.post(`/shop/${shopId}/purchase-order/setting`, update)
    .then((data) => {
      dispatch(poLocationUpdated(data));
      return data;
    })
);
